<script setup lang="ts">
type SweetPepperProps = {
  isOutline: boolean
  styles: {
    top: string
    left: string
    transform: string
    position: 'absolute' | 'fixed'
  }
  color?: string
}

const props = defineProps<SweetPepperProps>()

const getColor = (defaultColor: string) => {
  return props.color ? props.color : defaultColor
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1101.77 1022.51"
    :style="styles"
    class="-z-1 h-[25vh] w-[25vh] overflow-hidden"
  >
    <g id="a" />
    <g id="b" />
    <g id="c" />
    <g id="d">
      <path
        class="u"
        :fill="getColor('#c33d3a')"
        :fill-opacity="isOutline ? 0 : 1"
        :stroke-width="isOutline ? 10 : 0"
        stroke="#FFFFFF"
        d="M650.5,56.64c-28.16-21.63-61.32-39.88-96.83-39.31-35.51,.57-72.42,25.64-75.8,60.99-1.25,13.13,.13,29.99-11.8,35.62-5.31,2.5-11.51,1.55-17.33,.81-39.75-5.03-85.06,5.82-106.94,39.4-15.47,23.75-17,54.77-22.2,83.17-29.33-33.5-58.67-67.01-88-100.51-10.66-12.17-22.03-28.28-15.55-43.11,8.51-19.46,42.6-22.18,43.42-43.4,.38-9.84-7.61-18.05-16.14-22.97-27.49-15.86-66.27-7.9-85.3,17.5-14.34,19.14-17.16,45.07-12.46,68.52,4.71,23.45,16.17,44.95,28.35,65.53,16.28,27.51,49.77,91.65,88.7,130.35-25.11,7.26-53.82,7.75-75.96,21.94-47.64,30.55-42.66,107.26-86.81,142.67-20.98,16.83-51.22,22.45-66.28,44.73-20.5,30.32-.94,71.08,20.6,100.68,157.79,216.75,435.45,340.45,694.35,380.93,45.52,7.12,97.33,9.99,132.16-20.17,45.59-39.48,39.15-115.43,79.73-160.05,30.21-33.21,81.73-43.35,106.4-80.85,26.67-40.54,10.47-95.71-15.63-136.62-29.93-46.91-71.08-85.42-106.08-128.68-107.67-133.1-158.82-312.89-294.59-417.16Z"
      />
    </g>
    <g id="e" />
    <g id="f" />
    <g id="g" />
    <g id="h" />
    <g id="i" />
    <g id="j">
      <g id="k" />
      <g id="l" />
      <g id="m" />
      <g id="n" />
      <g id="o" />
      <g id="p" />
      <g id="q" />
      <g id="r" />
      <g id="s" />
      <g id="t" />
    </g>
  </svg>
</template>

<style scoped></style>
